import { Skeleton } from "@carry/ui";

interface TableSkeletonProps {
  rows?: number;
  columns: number;
}

export function TableSkeletonRows({ rows = 6, columns }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={`skeleton-${i}`} aria-hidden="true">
          {Array.from({ length: columns }).map((_c, j) => (
            <td key={j}>
              <Skeleton style={{ height: 12, width: "70%" }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
